import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useFormTokenChainContext } from '../../../hooks/context/useFormTokenChainContext';
import { GlobalLocationStateType } from '../../../types/types';

export const useActualFormToken = () => {
  const { formTokens } = useFormTokenChainContext();
  const { pathname, search, state } = useLocation<GlobalLocationStateType>();

  const actualToken = useMemo(() => {
    const tokenId = new URLSearchParams(search).get('token');
    if (tokenId) {
      const fromUserState = formTokens.nodes[tokenId];

      if (fromUserState) {
        return fromUserState;
      }

      if (state?.rootToken && state.rootToken.id === tokenId) {
        return state.rootToken;
      }
    }
    return null;
  }, [formTokens, search, pathname, state]);

  return actualToken;
};
